import { Component, h, Prop, State } from '@stencil/core'
import { getClassNames, getSitefinityValue } from '../../../lib/helper/global.helper'

@Component({
  tag: 'envc-footer-navigation',
  styleUrl: 'envc-footer-navigation.scss',
  shadow: false,
  scoped: true
})
export class EnvcFooterNavigation {

  @Prop() anchor: string
  @Prop() widgetId: string
  @Prop() headline: string
  @Prop({ mutable: true }) isAriaExpanded: boolean = window.innerWidth > 799

  // TODO find out what trackingAttributes look like and how can we pass them to the component
  @Prop() trackingAttributes: string

  @State() lastKnownWidth: number

  /**
   * Init - register resize event listeners
   */
  componentDidLoad() {
    window.addEventListener('resize', this._onWidthManipulationCallback.bind(this))
  }

  /**
   * Cleanup when the component is disconnected, removing event listeners.
   */
  disconnectedCallback() {
    window.removeEventListener('resize', this._onWidthManipulationCallback)
  }

  /**
   * Resize callback
   */
  _onWidthManipulationCallback() {
    const isMedium = window.matchMedia('(max-width: 799px)').matches,
      isSmall = window.matchMedia('(max-width: 499px)').matches,
      isLarge = window.matchMedia('(min-width: 800px)').matches,
      isSwitchFromMediumToSmall = isSmall && this.lastKnownWidth >= 500,
      isSwitchFromLargeToMedium = isMedium && this.lastKnownWidth >= 800,
      isSwitchFromMediumToLarge = isLarge && this.lastKnownWidth < 800

    /**
     * On switch to mobile - close the accordions
     * On switch to medium - close the accordions
     */
    if ((isSwitchFromMediumToSmall || isSwitchFromLargeToMedium) && this.isAriaExpanded === true) {
      this._toggleExpandedState(false)
    }

    /**
     * On switch to large - open the accordions
     */
    if (isSwitchFromMediumToLarge && this.isAriaExpanded === false) {
      this._toggleExpandedState(true)
    }

    this.lastKnownWidth = window.innerWidth
  }

  /**
   * Function to toggle the expanded state
   */
  _toggleExpandedState(state?: boolean) {
    if (state !== undefined) {
      this.isAriaExpanded = state
    } else {
      this.isAriaExpanded = !this.isAriaExpanded
    }
  }

  render() {
    return [
      !!this.anchor && <div id={getSitefinityValue(this.anchor)}></div>,
      <section
        id={this.widgetId}
        data-tpl={'acc01'}
        class={'acc--mobile-only'}
        data-elbcontext={getSitefinityValue(this.trackingAttributes)}
      >
        <ul>
          <li
            aria-expanded={this.isAriaExpanded.toString()}
            class={'accordion-item'}
          >
            <section>
              {
                this.headline && (
                  <div
                    onClick={() => this._toggleExpandedState()}
                    class={
                      getClassNames(['accordion-item__headline', ' h6'])
                    }
                  >
                    {this.headline}
                  </div>
                )
              }
              <article class={'accordion-item__content'}>
                <div data-tpl={'ll01'}>
                  <ul>
                    <slot></slot>
                  </ul>
                </div>
              </article>
            </section>
          </li>
        </ul>
      </section>
    ]
  }
}
